import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { renderToStaticMarkup } from 'react-dom/server';
import CloseIcon from '../../../../../commonComponents/icons/icon/CloseIcon';
import translate from '../../../../../commonComponents/translate';
import ServerSideList from '../../../../../commonComponents/lists/ServerSideList';
import Modal from '../../../../../commonComponents/modal/Modal';
import UserColumn from '../../../../../commonComponents/lists/columns/UserColumn';
import UserModalFilters from './UserModalFilters';

const initialStateModalFilters = {
  userNumber: undefined,
  user: undefined,
};

function UserModal(props) {
  const { t, onClose } = props;

  const [filters, setFilters] = useState(initialStateModalFilters);

  const tableUrL = '/table/user/network/list?includeMe=true';
  const tableId = 'mivitana_referrals';

  const columns = [
    {
      field: 'userNumber',
      textAlign: 'left',
      title: t('profile.userNumber'),
      sortable: false,
      template: user => user.userNumber,
      width: 100,
    },
    {
      field: 'username',
      textAlign: 'left',
      title: t('user'),
      sortable: false,
      template: user => renderToStaticMarkup(<UserColumn t={t} user={user} />),
      width: 250,
    },
    {
      field: 'forecast.isActive',
      textAlign: 'left',
      title: t('status'),
      sortable: false,
      template: user =>
        renderToStaticMarkup(
          <div>
            <img
              alt="active"
              src={
                user.forecast?.isActive
                  ? '/images/plan/active-icon.svg'
                  : '/images/plan/canceled-icon.svg'
              }
              className="active-checkbox"
            />
            <span>
              {user.forecast?.isActive ? t('plan.active') : t('plan.inactive')}
            </span>
          </div>,
        ),
      width: 100,
    },
    {
      field: 'activeUntil',
      textAlign: 'left',
      title: t('rewards_activeUntil'),
      sortable: false,
      template: user =>
        renderToStaticMarkup(
          <span>
            {user.forecast?.isActive && user.forecast?.activeUntil
              ? moment(user.forecast?.activeUntil).format('DD/MM/YYYY')
              : '-'}
          </span>,
        ),
      width: 200,
    },
    {
      field: 'personalVA',
      textAlign: 'left',
      title: t('report.mivitana.table.pv'),
      sortable: false,
      template: user => user.personalVA || 0,
      width: 150,
    },
  ];

  const handleFiltersChange = useCallback(
    field => value =>
      setFilters(prevState => ({ ...prevState, [field]: value })),
    [setFilters],
  );

  return (
    <Modal onClose={onClose} id="arcovaMonthlyDetailsModal">
      <div
        className="modal-dialog modal-dialog-centered modal-lg"
        role="document"
      >
        <div className="modal-content">
          <div className="modalTitle">
            <h5 className="title">{t('report.mivitana.userList')}</h5>
            <button type="button" onClick={onClose} className="closeIcon">
              <CloseIcon width="20" height="20" color="#6F6C80" />
            </button>
          </div>
          <div
            id="modalBodyMonthlyDetails"
            className="modal-body"
            style={{ maxHeight: '70vh', overflowY: 'auto' }}
          >
            <UserModalFilters
              filters={filters}
              onFilterChange={handleFiltersChange}
            />
            <ServerSideList
              dataSourceURL={tableUrL}
              dataSourceHeaders={{
                'Accept-Version': '1.0.0',
                'X-Gamification-API': 'Organization',
              }}
              columns={columns}
              query={filters}
              id={tableId}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
}

UserModal.propTypes = {
  t: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};
export default translate(UserModal);
